import { render, staticRenderFns } from "./ReviewRecordStep.vue?vue&type=template&id=22799148&scoped=true&"
import script from "./ReviewRecordStep.vue?vue&type=script&lang=js&"
export * from "./ReviewRecordStep.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRecordStep.vue?vue&type=style&index=0&id=22799148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22799148",
  null
  
)

export default component.exports